<template>
  <div id="app" :style="`font-family:${getFonts.principal}`"  :route="$route.name" :client="getBrand.name">
    <router-view/>
    <app-footer></app-footer>
    <error-banner></error-banner>
    <popup-revisar-perfil v-if="getRevisarPerfil"></popup-revisar-perfil>
    <cookie-law :buttonText="'Aceptar'" :theme="'base dotia'" v-if="!!getFooterLinks">
      <div slot="message">
        Utilizamos cookies. Si continúas navegando, consideramos que aceptas su uso. <a :href="getFooterLinks['Política de Cookies']" target="_blank" to="politica-de-cookies">Saber más</a>.
      </div>
    </cookie-law>
    
  </div>
</template>

<script>

  import footer from '@/components/parts/footer'
  import CookieLaw from 'vue-cookie-law'

  import errorBanner from '@/components/parts/error-banner'
  import revisarPerfil from '@/components/parts/popup-revisar-perfil'



  import {mapGetters,mapActions} from 'vuex';

  export default {
    name: 'App',
    mounted(){
      if(this.getLogged){
        setTimeout (e => {
          this.requestAllData();
        },500)
      }
    },
    components : {
      'app-footer' : footer,
      'cookie-law' : CookieLaw,
      'error-banner' : errorBanner,
      'popup-revisar-perfil' : revisarPerfil,
    },
    computed:{
      ...mapGetters([
        'getLogged',
        'getErrorCode',
        'basicColors',
        'getFonts',
        'getFooterLinks',
        'getRevisarPerfil',
        'getBrand',
      ]),
    },
    methods :{
      ...mapActions(['requestAllData','getColors']),
    }
  }
</script>

<style  lang="scss">
  @import '@/assets/css/colors.scss';
  @import './assets/css/style.scss';
  @import './assets/css/responsive.scss';
  @import './assets/css/brands.scss';
  @import './assets/css/slick.css';
  @import url('https://fonts.googleapis.com/css?family=Open+Sans:400,700');
  @import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);
  @import url(https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css);
</style>



// WEBPACK FOOTER //
// src/App.vue